import { ISchedule } from '@/utils/index.model';
import { API_URLS } from '@/utils/constant';
import { getData, keysToCamel } from '@/utils/helpers';
import { cloneDeep, find } from 'lodash';

interface IScheduleState {
  schedules: ISchedule[];
  schedule: ISchedule;
}

export const state = () => ({ schedules: [], schedule: {} });

export const mutations = {
  UPDATE_SCHEDULES(stateData: IScheduleState, schedules: ISchedule[]): void {
    stateData.schedules = [...schedules];
    if (stateData.schedule.id) {
      const schedule = cloneDeep(find(stateData.schedules, { id: stateData.schedule.id }));
      if (!schedule) return;
      stateData.schedule = { ...schedule };
    }
  },
  UPDATE_SCHEDULE(stateData: IScheduleState, schedule: ISchedule): void {
    stateData.schedule = { ...schedule };
  },
  RESET_SCHEDULE(stateData: IScheduleState) {
    stateData.schedules = [] as ISchedule[];
  },
};

export const actions = {
  updateSchedules(context: any): void {
    const { rootGetters } = context;
    const { language } = rootGetters['general/config'];
    const token = rootGetters['general/token'];
    const params = {
      page: 1,
      page_size: 6,
      lang: language,
    };
    // context.commit('UPDATE_SCHEDULES', SCHEDULE_MOCK_DATA);
    const currentTime = Date.now();
    getData(API_URLS.SCHEDULE, token, params)
      .then((res: any) => {
        res.map((r: any) => {
          const matchStartDateTime = new Date(r.match_start_date_time).getTime();
          r.matchDay = r.match_day ? r.match_day.arena.code : '';
          const isActive = r.match_day ? r.match_day.is_active : false;
          r.lastFightNumber = r.match_day ? r.match_day.last_fight_number : 0;
          r.startFightDateTime = r.match_day ? r.match_day.start_fight_date_time : 0;
          delete r.match_day;
          if (matchStartDateTime > currentTime) {
            r.eventType = 'future';
          } else if (matchStartDateTime <= currentTime && isActive) {
            r.eventType = 'current';
          } else {
            r.eventType = 'past';
          }
          return r;
        });
        context.commit('UPDATE_SCHEDULES', keysToCamel(res));
      })
      .catch((e: any) => console.log(e));
  },
  updateSchedule(context: any, schedule: ISchedule): void {
    context.commit('UPDATE_SCHEDULE', schedule);
  },
  resetSchedule(context: any): void {
    context.commit('RESET_SCHEDULE');
  },
};

export const getters = {
  schedules: (stateData: any): ISchedule[] => {
    return stateData.schedules;
  },
  schedule: (stateData: any): ISchedule => {
    return stateData.schedule;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
